<template>
  <div class="customerAutoComplete col-md-8">
    <textarea
      class="customerAutoComplete__textarea col-md-12"
      :rows="row"
      :value="value"
      @input="onInputChange"
    />
    <div
      class="customerAutoComplete__listContainer"
      v-show="isShowList"
      ref="optionsList"
    >
      <ul class="customerAutoComplete__list">
        <li class="customerAutoComplete__listItem" @click="onCloseList()">
          關閉
        </li>
        <li class="customerAutoComplete__listItem" @click="onGoogleSearch()">
          Google 查詢地址(點選)
        </li>
        <template v-if="isShowGoogleSearchList">
          <li
            class="customerAutoComplete__listItem customerAutoComplete__listItem--google"
            v-for="(googleAddr, idx) in googleAddrList"
            :key="'google' + googleAddr.address"
            @click="onAddr(googleAddr, idx, 'google')"
          >
            {{ googleAddr.address }}
          </li>
        </template>
        <li
          class="customerAutoComplete__listItem customerAutoComplete__listItem--general"
          v-for="(addr, idx) in addrList"
          :key="'db' + addr.address"
          :class="{ selected: selectedIdx === idx }"
          @click="onAddr(addr, idx, 'db')"
        >
          {{ addr.address }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  reqIntersection,
  reqSimilarAddress,
  reqDbAddress,
  reqGoogleAddress,
} from '@/api/driverMonitor'
import { options } from '@/constants/driverMonitor'
import { debounce } from 'lodash'
import { Notification } from 'element-ui'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    row: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      inputAddr: '',
      addrList: [],
      googleAddrList: [],
      isShowList: false,
      isShowGoogleSearchList: false,
      selectedAddr: { address: '', longitude: '', latitude: '' },
      selectedIdx: null,
    }
  },
  methods: {
    onInputChange: debounce(function (event) {
      this.inputAddr = event.target.value
      /* 同步parent component的state */
      this.$emit('input', this.inputAddr)
      /* 清空選單 */
      this.addrList = []
      this.googleAddrList = []
      /* 使用者輸入的字符數須大於5，才會動態的於公司資料庫或google搜尋地址 */
      if (this.inputAddr.length > 5) {
        this.setIntersectionAddr()
      }
    }, 1000),
    async setIntersectionAddr() {
      try {
        const isPipeInclude =
          this.inputAddr.includes('||') || this.inputAddr.includes('｜｜')
        const isPlusInclude = this.inputAddr
          .trim()
          .replace(/[ ]/g, '+')
          .includes('+')
        const promises = []
        if (isPipeInclude) {
          promises.push(reqIntersection(this.getParams(this.inputAddr, 'pipe')))
        }
        if (isPlusInclude) {
          promises.push(
            reqIntersection(
              this.getParams(
                this.inputAddr.trim().replace(/[ ]/g, '+'),
                'plus',
              ),
            ),
          )
        }
        if (promises.length) {
          const resPromiseAll = await Promise.all(promises)
          resPromiseAll.map(({ result }) => {
            if (result !== 'err') {
              const intersectionArr = result.intersectionInfo
              if (intersectionArr.length) {
                const addrList = []
                intersectionArr.forEach((obj) => {
                  const addrStr = `(${obj.town})${obj.city}${obj.intersection}||${obj.road}`
                  const newAddr = {
                    address: addrStr,
                    longitude: obj.Gps.coordinates[0],
                    latitude: obj.Gps.coordinates[1],
                  }
                  /* 去除重複元素 */
                  const existIdx = addrList.findIndex(
                    ({ address }) => address === newAddr.address,
                  )
                  if (existIdx === -1) {
                    addrList.push(newAddr)
                  }
                })
                this.addrList = addrList
                this.isShowList = true /* 展開選單 */
              }
            }
          })
        } else {
          this.setNormalAddr()
        }
      } catch (e) {
        console.error(e)
        Notification({
          message: '交叉路或歷史路名查詢查詢發生錯誤，請稍後再試',
          type: 'error',
        })
      }
    },
    async setNormalAddr() {
      try {
        const address = this.inputAddr.replace(/\(.*?\)/g, '')
        const resPromiseAll = await Promise.all([
          reqSimilarAddress({ address }),
          reqDbAddress({ address }),
        ])
        const result = { cityDistrictRoad: [], addressArray: [] }
        resPromiseAll.map((res) => {
          if (res.success) {
            result.cityDistrictRoad = result.cityDistrictRoad.concat(
              res.result.cityDistrictRoad,
            )
            result.addressArray = result.addressArray.concat(
              res.result.addressArray,
            )
          }
        })
        this.isShowList = true /* 即使沒有地址一樣展開選單，才能使用google搜尋 */
        if (result.addressArray.length) {
          const addrList = []
          result.addressArray.forEach(({ address, gps }) => {
            const newAddr = {
              address: address,
              longitude: gps.coordinates[0],
              latitude: gps.coordinates[1],
              /* gps: gps.coordinates, */
            }
            /* 去除重複元素 */
            const existIdx = addrList.findIndex(
              ({ address }) => address === newAddr.address,
            )
            if (existIdx === -1) {
              addrList.push(newAddr)
            }
          })
          this.addrList = addrList
        }
      } catch (e) {
        console.error(e)
        Notification({
          message: '查詢發生錯誤，請稍後再試',
          type: 'error',
        })
      }
    },
    getParams(addr, type) {
      let intersection = null
      if (type === 'pipe') {
        /* 地址帶有'|'字符*/
        intersection = addr
          .replace('市', '市 ')
          .replace(/\(.*?\)/g, '')
          .trim()
          .replace(/[ ]/g, '+')
          .replace('||', '+')
          .replace('｜｜', '+')
      } else if (type === 'plus') {
        /* 地址帶有'+'字符*/
        intersection = addr.replace('市', '市 ').replace(/[ ]/g, '+')
      } else {
        throw new Error('type argument is a required value')
      }
      const countryCode = this.OPTIONS.find((option) =>
        intersection.includes(option.country),
      ).value
      const roadList = intersection.split('+')
      const road = roadList[1] + ' ' + roadList[2]
      return {
        key: road,
        county_number: countryCode,
      }
    },
    onCloseList() {
      this.addrList = []
      this.googleAddrList = []
      this.isShowList = false
    },
    /* google search */
    async onGoogleSearch() {
      try {
        const { result } = await reqGoogleAddress(this.inputAddr)
        this.googleAddrList = result.map(
          ({ relatedAddress, latitude, longitude, formattedAddress }) => {
            return {
              address: relatedAddress,
              longitude: longitude,
              latitude: latitude,
              /* HACK: 目前判斷是無用，但是暫時保留 formattedAddress: formattedAddress, */
            }
          },
        )
      } catch (e) {
        console.error(e)
      } finally {
        if (this.googleAddrList.length) {
          this.isShowGoogleSearchList = true
        } else {
          this.isShowGoogleSearchList = false
        }
      }
    },
    /* 在地址的下拉選單中點擊地址 */
    onAddr(addr, idx, type) {
      if (!type) {
        throw new Error('type is a required argument')
      }
      /* 更新地址資料 */
      this.inputAddr = addr.address
      this.selectedIdx = idx
      this.selectedAddr = addr
      /* 同步parent component的input */
      this.$emit('input', this.inputAddr)
      /* emit function in parent component */
      this.$emit('getSelectedAddr', this.selectedAddr)
      this.onCloseList()
    },
    /* NOTE: 暫時保留，以下function的用途主要是由parent component呼叫 */
    /* getAddress() {
      return this.query
    },
    setAddressFromHistory(address) {
      this.isFoundAddress = true
      if (address === null) {
        this.initData()
        return
      }
      this.query = address
    },
    clearGoogleSearchArray() {
      this.addrDetailList = []
    },
    clearData() {
      this.selectedItem = null
      this.selected = 0
      this.query = cookies.get('GladArea')
      this.isShowList = false
      this.isShowAddrDetail = false
      this.addrDetailList = []
      this.isFoundAddress = false
      this.isUpOrDownOpt = false
    }, */
  },
  created() {
    this.OPTIONS = options
  },
}
</script>

<style scoped lang="scss">
.customerAutoComplete {
  position: relative;
  z-index: 100;
  padding: 0px;
  &__textarea {
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    /* background-color: dodgerblue; */
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__listContainer {
    padding: 0 10px;
    width: 100%;
    margin-top: 5px;
    position: absolute;
    top: 100%;
    left: 0;
  }

  &__list {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
    border: 2px solid black;
    max-height: 300px;
    overflow-y: auto;
  }

  &__listItem {
    border-bottom: 1px solid lightgray;
    font-size: 16px;
    color: black;
    padding: 10px;
    cursor: pointer;
    background: #f1f1f1;

    &:not(.selected):hover {
      background: #8c8c8c;
      color: black;
    }

    &.selected {
      background: #dfffc7;
      color: #e62e00;
      font-weight: 600;
    }

    &--google {
      background-color: #c2f0c2;
    }

    &--general {
      background-color: #ccebff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/AddrAutoComplete.vue